import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import Heading from '@magalu/stereo-ui/atoms/Heading';
import { usePublisher } from '@magalu/mixer-publisher';
import ProductBundleSelector from '../ProductBundleSelector';
import VisibilitySection from '../VisibilitySection';
import { Content, Description, WarningGenAI, StyledStarGroup, FeaturesList } from './SummaryTechnicalSheet.styles';
var baseTitle = {
  color: 'base',
  fontSize: 2,
  fontWeight: 'bold',
  lineHeight: 'display',
  my: [2, 2, 2, 2]
};
function SummaryTechnicalSheet(_ref) {
  var _keySellingPoint$item2;
  var data = _ref.data,
    staticProps = _ref.staticProps;
  var product = data.product,
    keySellingPoint = data.keySellingPoint;
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var _useInView = useInView({
      threshold: 0.5,
      triggerOnce: true
    }),
    ref = _useInView.ref,
    inView = _useInView.inView;
  useEffect(function () {
    var _keySellingPoint$item;
    if (inView && (keySellingPoint == null ? void 0 : (_keySellingPoint$item = keySellingPoint.items) == null ? void 0 : _keySellingPoint$item.length)) {
      publish('product:summaryTechnicalSheet');
    }
  }, [inView, keySellingPoint, publish]);
  if (!(keySellingPoint == null ? void 0 : (_keySellingPoint$item2 = keySellingPoint.items) == null ? void 0 : _keySellingPoint$item2.length)) {
    return null;
  }
  return React.createElement(VisibilitySection, {
    eventKey: "product:active:section",
    eventValue: "product:detail"
  }, React.createElement(Content, {
    ref: ref,
    "data-testid": "technical-sheet-detail"
  }, staticProps.label && React.createElement(Heading, _extends({}, baseTitle, {
    fontSize: [2, 2, 5, 5],
    fontWeight: "medium",
    "data-testid": "technical-sheet-detail-label",
    as: staticProps.labelAs || 'h2'
  }), staticProps.label), React.createElement(ProductBundleSelector, {
    data: product
  }), React.createElement(Description, {
    fontSize: [1, 1, 2, 2],
    "data-testid": "technical-sheet-detail-description"
  }, React.createElement(FeaturesList, null, keySellingPoint.items.map(function (feature) {
    return React.createElement("li", {
      key: feature
    }, feature);
  }))), React.createElement("div", {
    style: _extends({}, WarningGenAI)
  }, React.createElement(StyledStarGroup, null), "Informa\xE7\xF5es geradas pela Lu")));
}
SummaryTechnicalSheet.ssr = true;
SummaryTechnicalSheet.defaultProps = {
  staticProps: {
    label: 'Principais informações deste produto',
    labelAs: 'h2'
  }
};
process.env.NODE_ENV !== "production" ? SummaryTechnicalSheet.propTypes = {
  data: PropTypes.shape({
    keySellingPoint: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.string)
    }),
    product: PropTypes.shape({
      brand: PropTypes.shape({
        slug: PropTypes.string.isRequired
      }).isRequired,
      category: PropTypes.shape({
        id: PropTypes.string.isRequired
      }).isRequired,
      id: PropTypes.string.isRequired,
      subcategory: PropTypes.shape({
        id: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired,
  staticProps: PropTypes.shape({
    label: PropTypes.string,
    labelAs: PropTypes.string
  })
} : void 0;
export default SummaryTechnicalSheet;